import { localStorage, reqwestByBg, indexdb } from '@/util/chrome.api'
import githubApi from '@/util/github'
import { saveState, dbUpdate } from '@/util/localstorage'
import db from '@/util/db'

const exentionId = document.getElementById('j_little_star_extention_id') && document.getElementById('j_little_star_extention_id').innerText

function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time || 300)
  })
}

/**
 * 更新tag对应的内容
 * @param {*} Oldtags
 * @param {*} updateTags
 */
function updateTag(Oldtags, updateTags) {
  const ary = []
  Oldtags.forEach((tagOld) => {
    let updatedTag
    updateTags.forEach((tagNew) => {
      if (tagNew && tagNew._id === tagOld._id) {
        updatedTag = Object.assign(tagOld, tagNew)
      }
    })
    ary.push(updatedTag || tagOld)
  })
  return ary
}

/**
 * 更新localstorage
 */
async function updateStorage(state, rootState) {
  const id = rootState.user && rootState.user.user.id
  if (state.stars) dbUpdate('stars', { id, data: state.stars })
  if (state.tags) dbUpdate('tags', { id, data: state.tags })
  if (state.updatedTimeStamp) saveState('updatedTimeStamp-' + id, state.updatedTimeStamp || 0)
  saveState('starIndexFirst-' + id, state.starIndexFirst || 0)
  if (state.delStars) saveState('delStars-' + id, JSON.stringify(state.delStars))
}

export default {
  state: {
    userId: '',
    type: '',
    tags: [],
    stars: {},
    delStars: null,
    updatedTimeStamp: 0,
    progress: '',
    isUpdating: '',
    starIndexFirst: 0, // 第一个star_index，用于新的star添加进来，根据这个字段计算排序
    updateTagProgress: '0%',
  },
  mutations: {
    // 更新delStars数据
    updateDelStars(state, list) {
      state.delStars = list
      const id = this.state.user.user.id
      const ids = []
      list.forEach((item) => {
        item.unStar = true
        item.tags = []
        state.stars[item.id] = item
        ids.push(item.id)
      })

      // 更新最近删除数量
      state.tags.forEach((item) => {
        if (item.type === 'local_statistics' && item.name === '最近删除') {
          item.pids = ids
        }
      })

      window.localStorage.setItem('delStars-' + id, JSON.stringify(list))
    },
    // 记录拉取数据，更新tag的次数
    setUpdateTagsProgress(state, progress) {
      state.updateTagProgress = progress
    },
    /**
     * 多个unstar
     * @param {*} state
     * @param {*} ids
     */
    unstarUpdate(state, stars) {
      const map = {}
      const ids = []
      stars.forEach((star) => {
        ids.push(star.id)
        map[star.id] = true
        // 更新delStars
        state.delStars ? state.delStars.unshift(star) : state.delStars = [star]
        star.unStar = true
        star.isDeling = false
        star.delDone = false
        star.check = false
        star.tags = []
      })

      // ids正则
      state.tags.forEach((item) => {
        if (item.type === 'local_statistics' && item.name === '最近删除') {
          item.pids = item.pids.concat(ids)
        } else {
          item.pids = item.pids.filter((id) => {
            return !map[id]
          })
        }
      })

      // github pids为0要删除
      state.tags = state.tags.filter((item) => {
        return !(item.pids.length === 0 && item.type === 'github')
      })

      this.commit('setBroadcast', {
        type: 'starChange',
      })
      updateStorage(state, this.state)
    },
    update(state, data) {
      // state.tags.forEach((item) => {
      //   if (item.name === '所有项目') console.log(item.length)
      // })
      // // 如果有需要更新的tag，更新原来的tag
      let updatedTags
      if (data.updatedTags && data.updatedTags.length) {
        updatedTags = updateTag(state.tags, data.updatedTags)
      }
      // // 如果有新的tag，增加新的tag
      if (data.newTags && data.newTags.length) {
        updatedTags = data.newTags.concat(updatedTags || [])
      }
      // // 更新删除的star
      if (data.delStarPids && data.delStarPids.length) {
        for (const id of data.delStarPids) {
          delete state.stars[id]
        }
      }
      // state.tags = data.tags
      // state.stars = data.stars || ''
      if (data.stars) {
        // 可能会返回第二页的star，而不是全部star，所以需要使用这种更新操作
        if (data.pageStart && data.pageStart !== 1) {
          state.stars = {
            ...state.stars,
            ...data.stars,
          }
        } else {
          console.log('store-star-update-update-stars-all')
          state.stars = data.stars
        }
      }

      const pids = Object.keys(data.stars)
      console.log('store-star-update-update-stars-pids', pids)
      console.log('store-star-update-update-stars-90669846', data.stars[90669846])
      // console.log('updatedTags', updatedTags)
      if (data.tags || updatedTags) state.tags = updatedTags || data.tags

      state.tags.forEach((item) => {
        if (item.type === 'local_statistics' && item.name === '所有项目') {
          console.log('store-star-update-update-tag-all-pids', item.pids)
          console.log('store-star-update-update-tag-all-find-id', item.pids.indexOf(90669846))
        }
      })
      // if (data.stars) state.stars = data.stars
      // if (data.tags) state.tags = data.tags
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      state.starIndexFirst = 0
      updateStorage(state, this.state)
    },
    updateStars(state, stars) {
      state.stars = stars
      state.starIndexFirst = 0
      updateStorage(state, this.state)
    },
    updateTag(state, tags) {
      state.tags = tags
      updateStorage(state, this.state)
    },
    addTag(state, data) {
      state.tags = [
        data.tag,
        ...state.tags,
      ]
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      updateStorage(state, this.state)
    },
    delTag(state, data) {
      let newTags = state.tags.filter(tag => tag._id !== data.delTagId)
      if (data.noTag) {
        newTags = newTags.map((tag) => {
          return tag._id === data.noTag._id ? {
            ...tag,
            pids: data.noTag.pids,
            update_at: data.noTag.update_at,
          } : tag
        })
      }
      state.tags = newTags
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      updateStorage(state, this.state)
    },
    editTag(state, data) {
      const newTags = state.tags.map((tag) => {
        return tag._id === data.tag._id ? {
          ...tag,
          name: data.tag.name,
          update_at: data.tag.update_at,
          icon: data.tag.icon,
        } : tag
      })
      state.tags = newTags
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      updateStorage(state, this.state)
    },
    editStar(state, data) {
      // 更新原有的tag列表
      const updatedTags = updateTag(state.tags, data.updatedTags)
      // 获取这个star最新tag ids
      const starTagIds = []
      data.newTags.concat(updatedTags).forEach((tag) => {
        if (tag.type !== 'local_statistics' && tag.pids.includes(data.star.id)) starTagIds.push(tag._id)
      })
      state.tags = [
        ...updatedTags,
        ...data.newTags,
      ]
      if (data.star) {
        state.stars[data.star.id] = {
          ...data.star,
          tags: starTagIds,
        }
      }
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      updateStorage(state, this.state)
    },
    editMultiStar(state, res) {
      const data = res.data
      const stars = res.stars
      // 更新原有的tag列表
      const updatedTags = updateTag(state.tags, data.updatedTags)
      state.tags = [
        ...updatedTags,
        ...data.newTags,
      ]
      const tagIds = data.newTags.concat(data.updatedTags).map((tag) => {
        // 除了未分类tag，其他都加到list里面
        if (tag.type !== 'local_statistics') {
          return tag._id
        }
      })
      stars.forEach((item) => {
        const tags = item.tags || []
        state.stars[item.id] = {
          ...state.stars[item.id],
          check: false,
          tags: Array.from(new Set(tags.concat(tagIds))),
        }
      })
      // 更新stars
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      updateStorage(state, this.state)
    },
    newStar(state, data) {
      const updatedTags = updateTag(state.tags, data.updatedTags)
      const starsMap = {}
      data.stars.forEach((item) => {
        starsMap[item.id] = item
        item.isDeling = false
        item.delDone = false
        item.check = false
        item.unStar = false
        state.starIndexFirst = (state.starIndexFirst - 1) || 0
        starsMap[item.id].star_index = state.starIndexFirst
      })

      // 给所有star加上tagid
      data.newTags.concat(data.updatedTags).forEach((tag) => {
        if (tag.type !== 'local_statistics') {
          tag.pids.forEach(pid => {
            if (starsMap[pid]) {
              starsMap[pid].tags ? starsMap[pid].tags.push(tag._id) : starsMap[pid].tags = [tag._id]
            }
          })
        }
      })

      // 更新最近删除数量
      state.tags.forEach((item) => {
        if (item.type === 'local_statistics' && item.name === '最近删除') {
          item.pids = item.pids.filter((id) => !starsMap[id])
        }
      })

      state.tags = [
        ...updatedTags,
        ...data.newTags,
      ]
      state.stars = {
        ...state.stars,
        ...starsMap,
      }
      if (state.delStars) {
        state.delStars = state.delStars.filter((item) => {
          return !starsMap[item.id]
        })
      }
      updateStorage(state, this.state)
    },
    unStar(state, data) {
      const updatedTags = updateTag(state.tags, data.updatedTags)
      state.tags = [
        ...updatedTags,
      ]
      delete state.stars[data.starId]
      if (data.updatedTimeStamp) state.updatedTimeStamp = data.updatedTimeStamp
      updateStorage(state, this.state)
    },
    delTrashStars(state, ids) {
      const starsMap = {}
      ids.forEach((id) => {
        starsMap[id] = true
        delete state.stars[id]
      })
      // 更新最近删除数量
      state.tags.forEach((item) => {
        if (item.type === 'local_statistics' && item.name === '最近删除') {
          item.pids = item.pids.filter((id) => ids.indexOf(id) === -1)
        }
      })
      state.delStars = state.delStars.filter((item) => !starsMap[item.id])
      updateStorage(state, this.state)
    },
    initDatas(state, { tags, stars, starIndexFirst, isUpdating, updatedTimeStamp } = {}) {
      if (!this.state.user.user) return
      const id = this.state.user.user.id
      state.userId = id
      state.tags = tags || []
      state.stars = stars || {}
      const delStars = window.localStorage.getItem('delStars-' + id)

      // delStars
      state.delStars = delStars ? JSON.parse(delStars) : null
      if (state.delStars) {
        state.delStars.forEach((item) => {
          item.unStar = true
          state.stars[item.id] = item
        })
      }
      const index = starIndexFirst || window.localStorage.getItem('starIndexFirst-' + id)
      state.starIndexFirst = (index !== 'undefined' && index) || 0
      state.updatedTimeStamp = updatedTimeStamp || window.localStorage.getItem('updatedTimeStamp-' + id) || 0
    },
    /**
     * 改变同步请求状态
     */
    changeUpdateStatus(state, status) {
      state.isUpdating = status
      window.localStorage.setItem('updateStatus', status)
    },
  },
  actions: {
    async unStar({ commit }, stars) {
      const user = this.state.user.user

      if (!user) return Promise.reject('Login required')

      if (!this.state.user.accessToken) {
        this.commit('showTokenDialog')
        return Promise.reject('Token required')
      }

      const github = githubApi(user.github.login, this.state.user.accessToken || user.github.token)

      const promises = []

      for (let i = 0, length = stars.length; i < length; i++) {
        const name = stars[i].full_name.split('/')
        const req = github.activity.unstarRepoForAuthenticatedUser({
          owner: name[0],
          repo: name[1],
        })
        promises.push(req)
        if (i > 0 && i % 10 === 0) {
          await sleep(200)
        }
      }

      try {
        await Promise.all(promises)
      } catch (err) {
        err.type = 'github'
        return Promise.reject(err)
      }

      await this._vm.$http.put('/star/unstar', {
        stars: stars,
      })
      commit('unstarUpdate', stars)
    },
    async initDatas({ commit }, type) {
      if (!this.state.user.user) return
      const id = this.state.user.user.id
      let stars, tags, index
      let updatedTimeStamp = window.localStorage.getItem('updatedTimeStamp-' + id)
      // 如果有插件，先从插件更新，没有则从本地拉取数据
      let updatedTimeStampInExtention
      console.log(exentionId && typeof chrome !== 'undefined')
      if (exentionId && typeof chrome !== 'undefined') {
        try {
          updatedTimeStampInExtention = await localStorage({ type: 'getLocalStorage', key: 'updatedTimeStamp-' + id })
        } catch (e) {
          console.log(e)
          //
        }
      }

      if (exentionId && typeof chrome !== 'undefined' && updatedTimeStamp !== updatedTimeStampInExtention + '') {
        const starsFromDb = await indexdb({ type: 'getIndexDb', key: 'stars', data: id })
        stars = starsFromDb && starsFromDb.data
        const tagFromDb = await indexdb({ type: 'getIndexDb', key: 'tags', data: id })
        tags = tagFromDb && tagFromDb.data
        updatedTimeStamp = updatedTimeStampInExtention
        index = await localStorage({ type: 'getLocalStorage', key: 'starIndexFirst-' + id })

        // 保存在本地
        db.update('stars', { id, data: stars })
        db.update('tags', { id, data: tags })
        window.localStorage.setItem('updatedTimeStamp-' + id, updatedTimeStamp || 0)
        if (index && index !== 'undefined') window.localStorage.setItem('starIndexFirst-' + id, index)
      } else {
        const tagFromDb = await db.get('tags', id)
        tags = tagFromDb && tagFromDb.data
        const starsFromDb = await db.get('stars', id)
        stars = starsFromDb && starsFromDb.data

        index = window.localStorage.getItem('starIndexFirst-' + id)
        updatedTimeStamp = window.localStorage.getItem('updatedTimeStamp-' + id)
      }
      console.log('starIndexFirst', index)
      commit('initDatas', {
        type,
        tags: tags,
        stars: stars,
        starIndexFirst: index,
        updatedTimeStamp,
      })
    },
    /**
     * 删除的stars
     */
    getDelStars({ commit }) {
      return this._vm.$http.get('/star/trash').then((res) => {
        commit('updateDelStars', res.stars)
        return res.stars
      })
    },
    /**
     * 获取项目数据
     */
    getRepoInfo({ state }, fullName) {
      const url = `https://wk.littlestarcloud.com/repos/${fullName}`
      const headers = this.state.user.accessToken || (this.state.user.user && this.state.user.user.github.token) ? {
        authorization: `token ${this.state.user.accessToken || this.state.user.user.github.token}`,
      } : {}
      return this._vm.$http.get(url, {}, {
        headers,
      }).then((res) => {
        return res
      }).catch((err) => {
        err.type = 'githubReq'
        return Promise.reject(err)
      })
    },
    /**
     * 初始化content页面的state
     */
    initContentDatas({ commit, state }, type) {
      const id = this.state.user.user.id
      if (type === 'content') {
        const promiseTags = localStorage({ type: 'getLocalStorage', key: 'tags-' + id })
        const promiseStars = localStorage({ type: 'getLocalStorage', key: 'stars-' + id })
        const promiseIndx = localStorage({ type: 'getLocalStorage', key: 'starIndexFirst-' + id })
        const promiseTime = localStorage({ type: 'getLocalStorage', key: 'updatedTimeStamp-' + id })
        return Promise.all([
          promiseTags,
          promiseStars,
          promiseIndx,
          promiseTime,
        ]).then((res) => {
          commit('initDatas', {
            type,
            tags: res[0],
            stars: res[1],
            starIndexFirst: res[2],
          })
        })
      }
    },
    /**
     * @param {*} param0
     * @param {*} param1
     *  data 请求参数
     *  http 用于background 使用getStar action的时候，传入http
     */
    getStars({ commit }) {
      return this._vm.$http.get('/github/stars').then((res) => {
        if (res.stars) {
          commit('updateStars', res.stars)
        }
      })
    },
    /**
     * 更新stars的后备方案，从服务器拉取stars，更新tag
     * @param {} param0
     * @param {*} param1
     * @returns
     */
    updateStarsUseSev({ commit, state }, { data, http } = {}) {
      // 如果已经在更新中，则不能继续请求
      if (data && data.update && !data.pageStart && state.isUpdating === '1') return
      if (data && data.update) {
        commit('changeUpdateStatus', '1')
      }
      const req = this._vm.$http || http
      return req.get('/github/updatetagsbysev', data).then((res) => {
        commit('update', res)
        commit('setUpdateTagsProgress', parseInt(res.pageStart / res.totalPage * 100) + '%')
        if (res.pageRestart) {
          return this.dispatch('star/updateStarsUseSev', {
            data: {
              ...data,
              pageStart: res.pageRestart,
              update: res.update,
            },
            http,
          })
        } else {
          if (data && data.update) commit('changeUpdateStatus', '0')
          return res
        }
      }).catch((err) => {
        if (data.update) commit('changeUpdateStatus', '0')
        return Promise.reject(err)
      })
    },
    getTags({ commit }) {
      return this._vm.$http.get('/tag/tags').then((res) => {
        commit('updateTag', res.tags)
        return res
      })
    },
    async updateTags({ commit, state }, { http }) {
      const user = this.state.user.user

      if (!user || state.isUpdating === 1) return

      commit('changeUpdateStatus', '1')

      const github = githubApi(user.github.login, user.github.token)

      // 最大加载页数
      const maxLoadPage = 20
      // 每一个获取个数
      const starsNum = 100
      // 请求完成个数
      let requestDoneNum = 0
      // 开始分批获取数据
      const promises = []
      let allResult = []
      try {
        commit('setUpdateTagsProgress', '1%')

        // 记录更新次数
        const firstPageResult = await getRowStarData(this, github, 1, starsNum).then((res) => {
          requestDoneNum += 1
          return res
        })

        // 加入第一页
        allResult.unshift(firstPageResult)

        // 获取页数
        const totalPage = firstPageResult.headers.link ? parseInt(getPage(firstPageResult.headers), 10) : 1
        console.log(firstPageResult)
        // 控制同时请求的页数，不要太多
        const reqSplitTime = Math.ceil((totalPage - 1) / maxLoadPage)

        for (let time = 1; time <= reqSplitTime; time++) {
          // 从第二页开始：从第二批+1页开始
          let i = time === 1 ? 2 : (time - 1) * maxLoadPage + 1
          const length = time === reqSplitTime ? totalPage : time * maxLoadPage
          for (; i <= length; i++) {
            const promise = getRowStarData(this, github, i, starsNum).then((res) => {
              requestDoneNum += 1
              commit('setUpdateTagsProgress', parseInt(requestDoneNum / totalPage * 100) + '%')
              return res
            })
            promises.push(promise)
          }
          const result = await Promise.all(promises)
          allResult = allResult.concat(result)
        }

        let starData = {}
        allResult.forEach((result, index) => {
          const stars = starsDataFilter(result.data, index)
          starData = Object.assign(starData, stars)
        })

        if (totalPage !== requestDoneNum) {
          return Promise.reject({
            msg: 'Requst error, please try again!',
          })
        }

        const req = this._vm.$http || http
        const res = await req.post('/github/updatetags', {
          stars: starData,
        })
        attachTag(starData, res.tags)
        res.stars = starData
        commit('update', res)
        commit('changeUpdateStatus', '0')
      } catch (err) {
        commit('changeUpdateStatus', '0')
        // 如果出错，则重新尝试拉取多次
        await this.dispatch('star/updateStarsUseSev', {
          data: { update: true },
          http,
        })
      }
    },
    addTag({ commit }, data) {
      return this._vm.$http.post('/tag/', data).then((res) => {
        commit('addTag', res)
      })
    },
    delTag({ commit }, data) {
      return this._vm.$http.delete(`/tag/${data.tagId}`).then((res) => {
        commit('delTag', res)
      })
    },
    editTag({ commit }, data) {
      return this._vm.$http.put(`/tag/${data.tagId}`, data.body).then((res) => {
        commit('editTag', res)
      })
    },
    editStar({ commit, state }, data) {
      const req = state.type !== 'content' ? this._vm.$http.put('/star/tags', data.body) : reqwestByBg('put', '/star/tags', data.body)
      return req.then((res) => {
        commit('editStar', res)
      })
    },
    async editMultiStar({ commit, state }, data) {
      // 先执行star
      const user = this.state.user.user
      const github = githubApi(user.github.login, user.github.token)
      const promises = []
      for (let i = 0, length = data.stars.length; i < length; i++) {
        if (!user) break
        if (data.stars[i].unStar) {
          const name = data.stars[i].full_name.split('/')
          const req = github.activity.starRepoForAuthenticatedUser({
            owner: name[0],
            repo: name[1],
          })
          promises.push(req)
          if (i > 0 && i % 10 === 0) {
            await sleep(100)
          }
        }
      }
      await Promise.all(promises)
      return this._vm.$http.put('/star/multitags', data).then((res) => {
        commit('editMultiStar', { data: res, stars: data.stars })
      })
    },
    /**
     * 删除垃圾桶里面的star
     * @param {*} param0
     * @param {*} data
     */
    delTrashStars({ commit }, data) {
      return this._vm.$http.delete('/star/trash', data).then((res) => {
        commit('delTrashStars', data.ids)
      })
    },
    async newStar({ commit }, data) {
      if (!this.state.user.accessToken) {
        this.commit('showTokenDialog')
        return Promise.reject('Token required')
      }

      // 先执行star
      const user = this.state.user.user

      if (!user) return Promise.reject('Login required')

      const github = githubApi(user.github.login, this.state.user.accessToken || user.github.token)

      const promises = []

      for (let i = 0, length = data.stars.length; i < length; i++) {
        const name = data.stars[i].full_name.split('/')
        const req = github.activity.starRepoForAuthenticatedUser({
          owner: name[0],
          repo: name[1],
        })
        promises.push(req)
        if (i > 0 && i % 10 === 0) {
          await sleep(200)
        }
      }

      try {
        await Promise.all(promises)
      } catch (err) {
        err.type = 'github'
        return Promise.reject(err)
      }

      return this._vm.$http.post('/star/newstars', data).then((result) => {
        result.stars = data.stars
        commit('newStar', result)
      })
    },
    // unStar({ commit, state }, data) {
    //   if (!data.body.star) {
    //     return
    //   }
    //   const req = state.type !== 'content' ? this._vm.$http.put('/star/unstar/', data.body) : reqwestByBg('put', '/star/unstar/', data.body)
    //   return req.then((res) => {
    //     commit('unStar', res)
    //   })
    // },
  },
  namespaced: true,
}

// async function getStars(store) {

// }

/**
 * 分析star 页数
 * @param meta {Object}
 * @return page {Number}
 */
function getPage(meta) {
  const reg = /page=(\d+)&per_page=\d+>;\s*?rel="last"/i
  const match = meta.link.match(reg)
  return match ? match[1] : 0
}

/**
 * 过滤抓回来的数据，只保存，需要的数据
 * @param {Array} data
 */
function starsDataFilter(data, page) {
  const collector = {}
  // const timeStamp = parseInt(new Date().getTime() / (1000 * 60), 10)
  data.forEach((item, index) => {
    collector[item.id] = starDataFilter(item)
    // time stamp 分页的话，后面的timestamp会大一点
    collector[item.id].star_index = (page * 100) + index
    // collector.req[item.id] = starDataFilter(item)
  })
  return collector
}

/**
 * 过滤star项目的信息
 * @param {Array} data
 */
function starDataFilter(data) {
  return {
    id: data.id,
    name: data.name,
    full_name: data.full_name,
    private: data.private,
    url: data.url,
    html_url: data.html_url,
    description: data.description,
    fork: data.fork,
    created_at: data.created_at,
    updated_at: data.updated_at,
    git_url: data.git_rul,
    ssh_url: data.ssh_url,
    clone_url: data.clone_url,
    svn_url: data.svn_url,
    homepage: data.homepage,
    stargazers_count: data.stargazers_count,
    watchers_count: data.watchers_count,
    language: data.language,
    forks_count: data.forks_count,
    mirror_url: data.mirror_url,
    open_issues_count: data.open_issues_count,
    forks: data.forks,
    open_issues: data.issues,
    watchers: data.wathcers,
    tags: data.tags,
    visited: data.visited,
    like: data.like,
  }
}
/**
 * 为stars添加上tag数据
 * @param {Object} stars
 * @param {Array} tags
 * @return {Object} stars
 */
function attachTag(stars, tags) {
  tags.forEach((tag) => {
    if (tag.type === 'local_statistics') return
    tag.pids.forEach((pid) => {
      if (!stars[pid]) return
      if (!stars[pid].tags) stars[pid].tags = []
      stars[pid].tags.push(tag._id)
    })
  })
  return stars
}

/**
 * 使用octkit获取stars数据
 */
function getRowStarData(store, github, page, numPerPage, repeatTime) {
  return new Promise((resolve, reject) => {
    github.activity.listReposStarredByAuthenticatedUser({ page: page, per_page: numPerPage }).then((result) => {
      resolve(result)
    }).catch((err) => {
      if (err.status === 401) {
        reject(err)
        return
      }
      if (!repeatTime || repeatTime < 5) {
        setTimeout(() => {
          getRowStarData(store, github, page, numPerPage, repeatTime ? repeatTime + 1 : 1).then((res) => {
            resolve(res)
          }).catch((err) => {
            reject(err)
          })
        }, 500)
      } else {
        reject(err)
        // throw err
      }
    })
  })
}
